import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative mx-auto flex min-h-[70vh] w-full max-w-3xl flex-col items-center justify-center px-4 py-20 text-center">
      <span className="pointer-events-none absolute inset-0 flex select-none items-center justify-center font-heading text-[10rem] font-black leading-none text-background-200 md:text-[14rem]">
        404
      </span>
      <div className="relative z-10">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-100 text-primary-700">
          <i className="ri-compass-3-line text-3xl"></i>
        </span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950">没有找到这个页面</h1>
        <p className="mt-3 text-sm text-foreground-500">
          路径 <span className="font-label text-foreground-700">{location.pathname}</span> 不存在，它可能已被移除或链接有误。
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/news"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-label text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-newspaper-line"></i>
            浏览最新资讯
          </Link>
        </div>
      </div>
    </div>
  );
}